import { render, staticRenderFns } from "./CreatorServiceRemoveConfirm.vue?vue&type=template&id=34fdeb94&"
import script from "./CreatorServiceRemoveConfirm.vue?vue&type=script&lang=ts&"
export * from "./CreatorServiceRemoveConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports